import React from "react";
import Box from "@mui/material/Box";
import SingleStepper from "./SingleStepper";

const AdxProgressStepper = ({
  data,
  sxTextContainer,
  lastActiveSubtitle,
  lastInactiveSubtitle,
}) => {
  return data ? (
    <Box>
      <SingleStepper
        active={data.status !== "DRAFT" ? true : false}
        activeSubtitle="Submitted"
        disableLine={data.status === "DRAFT"}
        name={data.employeeName}
        imgUrl={data.employeePicture}
        date={data.submittedDate}
        sxTextContainer={sxTextContainer}
      />
      {data.approvalRoute && data.status !== "DRAFT"
        ? data.approvalRoute.map((item, index, array) => (
            <SingleStepper
              key={index}
              active={item.approvalStatus}
              disableLine={data.approvalRoute.length - 1 === index}
              inactiveSubtitle="Awaiting approval"
              name={item.employeeName}
              imgUrl={item.employeePicture}
              date={item.approvedDate}
              sxTextContainer={sxTextContainer}
              lastIndex={index === array.length - 1}
              lastActiveSubtitle={lastActiveSubtitle}
              lastInactiveSubtitle={lastInactiveSubtitle}
              isRejected={
                item.approvalStatus === 0 && item.approvedDate !== null
              }
            />
          ))
        : null}
    </Box>
  ) : null;
};

export default AdxProgressStepper;
